<template>
  <div>
    <weather
      v-for="(period, index) in days"
      :id="'weather_' + index"
      :key="'weather_' + index"
      class="col d-flex flex-column text-center"
      :day="period"
    />
  </div>
</template>

<script>
import Weather from './weather.vue';

export default {
  name: 'ExtendedWeather',
  components: {
    Weather,
  },
  props: {
    days: {
      type: Object,
      required: true,
    },
  },
};
</script>
